import script from "./ConfigView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigView.vue?vue&type=script&setup=true&lang=js"

import "./ConfigView.vue?vue&type=style&index=0&id=8123a196&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8123a196"]])

export default __exports__